import styled from 'styled-components';

const MinTitleStyle = styled.div`
	&.title {
		margin-bottom: var(--titleToText);
		will-change: opacity;
	}
`;

export default MinTitleStyle;
